<template>
  <mock-up-main>

    <div
      v-if="loading"
      class="fill-height d-flex align-center justify-center white"
      style="position: absolute; inset: 0; z-index: 10"
    >
      <v-progress-circular color="primary" height="5" indeterminate />
    </div>
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value?.visitName || 'صفخه کاری'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="value?.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>


    <div style="position: relative">
      <!-- bannerSection -->
      <b-intro-slider-view
        v-if="value"
        v-model="computedBanner"
        :is-slider="false"
      />
      <!-- bannerSection -->

      <!-- servicesSection -->
      <b-service-view
        v-if="hasServices"
        v-model="value.service"
        :description="value.Service.description"
        :style="{
          background: value.Service.sectionColor.backGround,
          color: value.Service.sectionColor.text,
        }"
        :color="value.Service.sectionColor.text"
        :title="value.Service.title"
        type="icon"
      />
      <!-- servicesSection -->

      <!-- faqection -->
      <b-faq-view
        v-if="!!value.faq && !!value.faq.items.length"
        v-model="value.faq"
        :style="{
          background: value.faq.sectionColor.backGround,
          color: value.faq.sectionColor.text,
        }"
      />
      <!-- faqection -->

      <!-- gallerySection -->
      <gallery-slider
        v-if="value.PicSelector && hasGallery && value.PicSelector.slider"
        v-model="value.gallery"
        :description="value.PicSelector.description"
        :style="{
          background: value.PicSelector.sectionColor.backGround,
          color: value.PicSelector.sectionColor.text,
        }"
        :title="value.PicSelector.title"
      />

      <b-gallery-view
        v-else-if="value.PicSelector && hasGallery"
        v-model="value.gallery"
        :description="value.PicSelector.description"
        :is-img="true"
        :style="{
          background: value.PicSelector.sectionColor.backGround,
          color: value.PicSelector.sectionColor.text,
        }"
        :title="value.PicSelector.title"
        is-grid
        new-position
      />
      <!-- gallerySection -->

      <!-- VideogallerySection -->
      <b-gallery-view
        v-if="
          value.VideoGallery &&
          value.video_gallery &&
          !value.VideoGallery.slider &&
          value.VideoGallery.sectionColor
        "
        v-model="value.video_gallery"
        :description="value.VideoGallery.description"
        :is-img="false"
        :style="{
          background: value.VideoGallery.sectionColor.backGround,
          color: value.VideoGallery.sectionColor.text,
        }"
        :title="value.VideoGallery.title"
        type="video_gallery"
      />
      <!-- VideogallerySection -->

      <!-- pdfSection -->
      <div v-if="value.pdf && value.pdf.length > 0">
        <pdf-preview-display
          :pdf-data="value.pdf"
          :layout-mode="layoutPreference"
          :pdf-selector="value.pdfSelector"
        />
      </div>
      <!-- <b-gallery-view
        v-if="value.pdfSelector && value.pdf && !value.pdfSelector.slider"
        v-model="value.pdf"
        :description="value.pdfSelector.description"
        :is-img="true"
        :style="{
          background: value.pdfSelector.sectionColor.backGround,
          color: value.pdfSelector.sectionColor.text,
        }"
        :title="value.pdfSelector.title"
        type="pdf"
      /> -->
      <!-- gallerySection -->

      <!-- <gallery-slider
        v-else-if="value.pdfSelector && !!value.pdf"
        v-model="value.pdf"
        :description="value.pdfSelector.description"
        :title="value.pdfSelector.title"
        type="pdf"
      /> -->
      <!-- pdfSection -->

      <b-blog-view
        v-if="hasBlog"
        v-model="value.blog"
        :description="value.Blog.description"
        :style="{
          background: value.Blog.sectionColor.backGround,
          color: value.Blog.sectionColor.text,
        }"
        :bstyle="value.Blog.sectionColor"
        :title="value.Blog.title"
        :type="value.Blog.slider ? 'slider' : 'default'"
      />

      <ads-components
        v-if="
          !!value.Product &&
          !!value.Product.items &&
          value.Product.items.length > 0
        "
        v-model="value.Product"
      />

      <b-section-view
        v-if="value.ServiceSection && value.ServiceSection.items.length > 0"
        v-model="value.ServiceSection"
      />

      <b-feedback-view
        v-if="value.FeedBack && value.FeedBack.items.length > 0"
        v-model="value.FeedBack"
      />

      <b-testimonials-view
        v-if="value.CounterService && value.CounterService.items.length > 0"
        v-model="value.CounterService"
      />
      <!-- 
      <forms-ui
        v-if="
          value.consultation &&
          value.consultation.items &&
          Object.values(value.consultation.items).filter(
            (item) => item.is_active
          ).length > 0
        "
        v-model="value.consultation.items"
        :description="value.consultation.description"
        :style="{
          background: value.consultation.sectionColor.backGround,
          color: value.consultation.sectionColor.text,
        }"
        :title="value.consultation.title"
      /> -->

      <consultation-new-show
        :style="{
          background: value.consultationNew?.sectionColor?.backGround,
          color: value.consultationNew?.sectionColor?.text,
        }"
        :color="value.consultationNew?.sectionColor?.text"
        v-model="value.consultationNew"
      />

      <team-ui
        v-if="
          !!value.Personnel &&
          !!value.Personnel.items &&
          !!value.Personnel.items.length
        "
        v-model="value.Personnel"
      />

      <count-down
        v-if="value.Counter && value.Counter.until"
        v-model="value.Counter.until"
        :description="value.Counter.description"
        :title="value.Counter.title"
      />

      <b-footer-view
        v-if="value.textCards"
        v-model="value"
        :style="{
          background: value.textCards.sectionColor.backGround,
          color: value.textCards.sectionColor.text,
        }"
        class="mt-10"
      />
    </div>

    <template v-slot:extension>
      <v-btn
        color="pink"
        dark
        fab
        small
        style="position: absolute; right: 25px; bottom: 75px; z-index: 99"
        @click="getVcf"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
  </mock-up-main>
</template>

<script>
import BIntroSliderView from "./bIntroSliderView";
import BFooterView from "./bFooterView";
import BFaqView from "./bFaqView";
import BGalleryView from "./bGalleryView";
import GallerySlider from "@/view/pages/businessPage/components/view/gallerySlider";
import bServiceView from "../../../commercial/components/view/bServiceView.vue";
import BBlogView from "./bBlogView";
import BFeedbackView from "./bFeedbackView";
import MockUpMain from "@/view/pages/businessPage/components/mockUp";
import FormsUi from "@/view/components/formsUi";
import BTestimonialsView from "./bTestimonialsView";
import BSectionView from "./bSectionView";
import CountDown from "@/view/pages/businessPage/pages/shopPage/components/countDown";
import TeamUi from "@/view/components/Personnel/teamUi";
import axios from "axios";
import AdsComponents from "@/view/components/Product/AdsComponents";
import ConsultationNewShow from "../../../../components/consultationNew/consultationNewShow.vue";
import PdfPreviewDisplay from "@/view/components/Gallery/PdfPreviewDisplay";
import UniversalQrModal from "../../../../components/UniversalQrModal.vue";

export default {
  name: "viewPage",

  components: {
    PdfPreviewDisplay,
    AdsComponents,
    TeamUi,
    CountDown,
    BSectionView,
    FormsUi,
    BTestimonialsView,
    MockUpMain,
    BFeedbackView,
    bServiceView,
    BGalleryView,
    BFaqView,
    BFooterView,
    BIntroSliderView,
    GallerySlider,
    BBlogView,
    ConsultationNewShow,
    PdfPreviewDisplay,
    UniversalQrModal
  },

  props: {
    value: Object,
    loading: Boolean,
    qrSvgDataUrl: {
      type: String,
      default: "",
    },

  },
  data: () => ({
    showQrDialog:false,
  }),
  computed: {
    primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },
    layoutPreference() {
      if (this.value.pdfSelector && this.value.pdfSelector.slider) {
        return "slider";
      }
      if (this.value.pdfSelector && this.value.pdfSelector.layout) {
        return this.value.pdfSelector.layout;
      }

      return "list";
    },

    hasGallery() {
      return (
        this.value.gallery?.length > 0 &&
        this.value.gallery?.filter((item) => item.images?.length > 0)?.length >
          0
      );
    },
    hasServices() {
      return (
        !!this.value.service?.length &&
        !!this.value.service.filter(
          (item) =>
            !!item.content ||
            (!!item.gallery?.length && !!item.gallery[0].images.length),
        ).length
      );
    },
    hasBlog() {
      return (
        !!this.value.blog?.length &&
        !!this.value.blog.filter(
          (item) =>
            !!item.content ||
            (!!item.gallery?.length && !!item.gallery[0].images.length),
        ).length
      );
    },
    computedBanner() {
      if (this.value?.banner?.gallery && this.value.banner.gallery[0])
        return {
          banner: this.value.banner.gallery[0],
        };
      else {
        return null;
      }
    },
  },

  watch: {
    value: {
      deep: true,

      handler() {
        this.$forceUpdate();
      },
    },
  },

  methods: {
    getVcf() {
      this.vcfLoading = true;

      const info = {
        fax: undefined,
        email: undefined,
        visitName: undefined,
        organizationName: undefined,
        subOrgan: undefined,
        phoneNumber: undefined,
        companyNumber: undefined,
        location: undefined,
        city: undefined,
        photo: undefined,
        codePostal: undefined,
        province: undefined,
        country: undefined,
        website: undefined,
        socialMedia: undefined,
        aboutUs: undefined,
        address: undefined,
      };

      Object.keys(info).forEach((x) => {
        info[x] = this.value[x];
      });
      axios
        .post(process.env.VUE_APP_VCF, info)
        .then((x) => {
          var a = document.createElement("a"); //Create <a>
          a.href = "data:text/vcard;charset=utf-8;base64," + x.data; //Image Base64 Goes here
          a.download = `${info.visitName}.vcf`; //File name Here
          a.click(); //Downloaded file
        })
        .finally(() => (this.vcfLoading = false));
    },
  },
};
</script>

<style scoped>
.qr-floating-btn {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}
</style>
